import { render, staticRenderFns } from "./btnGroup.vue?vue&type=template&id=5a04064a&scoped=true"
import script from "./btnGroup.vue?vue&type=script&lang=js"
export * from "./btnGroup.vue?vue&type=script&lang=js"
import style0 from "./btnGroup.vue?vue&type=style&index=0&id=5a04064a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a04064a",
  null
  
)

export default component.exports